
export default {
  major: 'major/',
  auth: '',
  home:'',
  enroll:'enroll/',
  edu: 'edu/'
}
